import AxiosService from "../../../services/axios-service";

export default class InsuranceRepository {

  static async saveData(data) {
    try {
      const axiosService = new AxiosService();
			const response = await axiosService.put(`webapp/insurance/saveData`, data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getPeriods() {
    try {
      const axiosService = new AxiosService();
			const response = await axiosService.get(`webapp/insurance/periods`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getPdfUrl(insuranceId) {
    try {
      const axiosService = new AxiosService();
			const response = await axiosService.post(`insurance/generate-pdf/${insuranceId}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
}